import { render, staticRenderFns } from "./TranslationStat.vue?vue&type=template&id=a978b73e&scoped=true"
import script from "./TranslationStat.vue?vue&type=script&lang=js"
export * from "./TranslationStat.vue?vue&type=script&lang=js"
import style0 from "./TranslationStat.vue?vue&type=style&index=0&id=a978b73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a978b73e",
  null
  
)

export default component.exports